import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Dialog} from 'primeng/dialog';
import {ButtonDirective} from 'primeng/button';
import {PrimeTemplate} from 'primeng/api';
import {IconBoldRam2Component} from '@components/icons/icon-bold-ram-2/icon-bold-ram-2.component';
import {IconBoldCloseSquareComponent} from '@components/icons/icon-bold-close-square/icon-bold-close-square.component';
import {
  FormRepresentacaoGovbrComponent
} from '@pages/demandas/form-representacao-govbr/form-representacao-govbr.component';

@Component({
  selector: 'app-cadastro-representacao-user-govbr',
  standalone: true,
  imports: [
    Dialog,
    ButtonDirective,
    PrimeTemplate,
    IconBoldRam2Component,
    IconBoldCloseSquareComponent,
    FormRepresentacaoGovbrComponent,
  ],
  templateUrl: './cadastro-representacao-user-govbr.component.html',
  styleUrl: './cadastro-representacao-user-govbr.component.css',
})
export class CadastroRepresentacaoUserGovbrComponent implements OnInit {
  @Input() showCadastroTipoRepresentacaoDialog = false;
  @Output() showCadastroTipoRepresentacaoDialogChange = new EventEmitter<boolean>();
  @ViewChild(FormRepresentacaoGovbrComponent) formRepresentacaoGovbrComponent!: FormRepresentacaoGovbrComponent;

  constructor(private readonly router: Router) {
  }

  ngOnInit(): void {
    this.showCadastroTipoRepresentacaoDialog = true;
  }

  get showLoadingSaveButton(): boolean {
    return this.formRepresentacaoGovbrComponent?.showLoadingSaveButton ?? false;
  }

  onCloseCadastroRepresentacaoDialog(): void {
    this.showCadastroTipoRepresentacaoDialog = false;
    this.showCadastroTipoRepresentacaoDialogChange.emit(false);
    this.router.navigate(['/']).then(() => console.info('Redirect to home'));
  }
}
